import cn from 'classnames';

import PdfPageImage from '../../@common/PdfPageImage';
import { V2PageType } from '../index.types';

import * as Styled from './index.styles';

interface Props {
  pageData: V2PageType;
  sizes?: string;
  isBlind?: boolean;
  loading?: 'eager' | 'lazy';
  onLoad?: () => void;
}

/** WebP srcset(imageSources) 우선, 없으면 레거시 단일 이미지로 렌더한다 */
const V2PageImage = ({ pageData, sizes, isBlind, loading, onLoad }: Props) => {
  if (pageData.imageSources?.viewer) {
    return (
      <PdfPageImage
        viewer={pageData.imageSources.viewer}
        alt={`pdf${pageData.page}page`}
        sizes={sizes}
        isBlind={isBlind}
        loading={loading}
        onLoad={onLoad}
      />
    );
  }

  return (
    <Styled.LegacyPageImage
      className={cn({ 'is-blind': isBlind })}
      src={pageData.src}
      alt={`pdf${pageData.page}page`}
      decoding="async"
      loading={loading}
      draggable={false}
      onLoad={onLoad}
    />
  );
};

export default V2PageImage;
